export default __webpack_public_path__ + "static/univers-light-a8d7b8bed74e7e776b6eed277119a787.woff2";